import React from "react";
import { LuRadio } from "react-icons/lu";
import { PIECE } from "./utils/c4Logic";

const DOT = {
  [PIECE.ONE]: "linear-gradient(145deg, #356da4 0%, #17375f 52%, #07111f 100%)",
  [PIECE.TWO]: "linear-gradient(145deg, #8f1212 0%, #520808 48%, #190202 100%)",
};

export default function ConnectFourStatusBar({
  status,
  currentTurn,
  myPiece,
  winner,
  p1Name,
  p2Name,
  isAI,
  wsStatus,
  maxWidthStyle,
}) {
  const p1Label = p1Name || "Player 1";
  const p2Label = isAI ? "AI" : (p2Name || "Player 2");

  const statusText = () => {
    if (status === "waiting") return "Waiting for opponent…";
    if (status === "loading") return "Loading…";
    if (status === "won") {
      if (winner === myPiece) return "You won!";
      if (myPiece) return "You lost.";
      return winner === PIECE.ONE ? `${p1Label} wins!` : `${p2Label} wins!`;
    }
    if (status === "draw") return "Draw!";
    if (status === "playing") {
      if (myPiece) {
        return currentTurn === myPiece ? "Your turn" : "Opponent's turn";
      }
      return currentTurn === PIECE.ONE ? `${p1Label}'s turn` : `${p2Label}'s turn`;
    }
    return "";
  };

  return (
    <div
      className="
        w-full mx-auto mb-2 min-h-[78px]
        [@media(min-width:768px)_and_(max-height:700px)]:mb-1.5
        [@media(min-width:768px)_and_(max-height:700px)]:min-h-[68px]
      "
      style={{ maxWidth: maxWidthStyle || "min(92vw, 640px)" }}
    >
      <div className="flex h-8 items-center justify-between gap-2 overflow-hidden">
        <span className="inline-flex h-8 items-center rounded-full border border-border-soft bg-slate-950/45 px-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-text-muted">
          {isAI ? "vs AI" : "Multiplayer"}
        </span>
        {wsStatus ? (
          <span className="inline-flex h-8 items-center gap-1.5 rounded-full border border-brand-cyan/20 bg-brand-cyan/10 px-3 text-[10px] font-semibold uppercase tracking-[0.08em] text-brand-cyan">
            <LuRadio size={11} />
            {wsStatus === "connected" ? "Live" : wsStatus}
          </span>
        ) : null}
      </div>

      <div className="mt-2 flex h-10 items-center justify-between gap-2 [@media(min-width:768px)_and_(max-height:700px)]:mt-1.5">
        {/* Player labels */}
        <div className="hidden h-10 items-center gap-2 rounded-2xl border border-black/60 bg-slate-950/45 px-3 sm:flex">
          <PieceDot piece={PIECE.ONE} />
          <span className="text-xs text-text-secondary">{p1Label}</span>
        </div>

        {/* Status */}
        <span className="flex h-10 min-w-0 flex-1 items-center justify-center rounded-2xl border border-black/60 bg-[linear-gradient(145deg,#0b1117,#030607)] px-3 text-center font-display text-sm font-semibold tracking-tight text-text-primary shadow-[inset_0_1px_0_rgba(255,255,255,0.055),0_10px_24px_rgba(0,0,0,0.28)] sm:text-base">
          {statusText()}
        </span>

        <div className="hidden h-10 items-center gap-2 rounded-2xl border border-black/60 bg-slate-950/45 px-3 sm:flex">
          <span className="text-xs text-text-secondary">{p2Label}</span>
          <PieceDot piece={PIECE.TWO} />
        </div>
      </div>
    </div>
  );
}

function PieceDot({ piece }) {
  return (
    <span
      className="h-3 w-3 rounded-full border border-black/70"
      style={{ background: DOT[piece] }}
      aria-hidden="true"
    />
  );
}
